import React, { useEffect, useState } from 'react'
import { Chart } from 'primereact/chart';
import { expenseApi } from '../../services';
import { Fieldset } from 'primereact/fieldset';
import { Dropdown } from 'primereact/dropdown';

const ExpenseDashboard = () => {
    const [userGraphData, setUserGraphData] = useState({});
    const [userChartOptions, setUserChartOptions] = useState({});
    //if the current month is february then date is set to current financial year
    const currYear = parseInt(new Date().getMonth()) > 2 ? parseInt(new Date().getFullYear()) + '-' + parseInt(new Date().getFullYear() + 1) : parseInt(new Date().getFullYear() - 1) + '-' + parseInt(new Date().getFullYear());
    const [date, setDate] = useState(currYear);
    const [categoryChartData, setCategoryChartData] = useState({});
    const [projectChartData, setProjectChartData] = useState(null);
    const startYear = 2023;

    function generateFinancialYearsArray(startYear) {
        const currentYear = new Date().getFullYear();
        let financialYears = [];

        for (let year = startYear; year <= currentYear; year++) {
            financialYears.push(`${year}-${year + 1}`);
        }
        return financialYears;
    }

    useEffect(() => {
        getUserWiseClaimAmount();
        getCategoryWiseClaimData();
    }, [date])


    const getCategoryWiseClaimData = () => {
        expenseApi.getCategoryWiseClaim(date).then((resp) => {
            const allCategories = new Set();
            Object.values(resp.data.data).forEach(month => {
                Object.keys(month).forEach(category => {
                    allCategories.add(category);
                });
            });

            const transformedData = {};

            allCategories.forEach(category => {
                transformedData[category] = Object.values(resp.data.data).map(month => month[category] || null);
            });

            const randomRgbColor = () => {
                let r = Math.floor(Math.random() * 256);
                let g = Math.floor(Math.random() * 256);
                let b = Math.floor(Math.random() * 256);
                return 'rgb(' + r + ',' + g + ',' + b + ')';
            };


            let arr = [];
            Object.keys(transformedData).map(td => {
                let obj = {};
                obj.label = td;
                obj.backgroundColor = randomRgbColor();
                obj.data = transformedData[td];
                arr.push(obj);
            })
            setCategoryChartData({
                labels: Object.keys(resp.data.data),
                datasets: arr
            })

        })
    }

    const getUserWiseClaimAmount = async () => {
        const resp = await expenseApi.getTeamClaimAmountUserWise(date);
        const Claimeduser = resp.data.data.map(item => item.userName);
        const claimAmounts = resp.data.data.map(item => item.totalClaim);
        const colors = [];
        for (let i = 0; i < Claimeduser.length; i++) {
            const randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
            colors.push(randomColor);
        }

        const data = {
            labels: Claimeduser,
            datasets: [{
                data: claimAmounts,
                backgroundColor: colors,
            }]
        };
        const options = {
            cutout: '60%'
        };
        setUserGraphData(data);
        setUserChartOptions(options);
    }

    return (
        <div className='mt-2 ess-page'>
            <div className="ml-2">
                <label htmlFor="yearpicker" ><strong>Select Financial Year: </strong></label>
                <Dropdown className='ml-2' value={date} options={generateFinancialYearsArray(startYear)} onChange={(e) => setDate(e.value)} placeholder="Select a year" />
            </div>
            <hr />
            <div className='grid  mt-3'>
                <div className="col-12 md:col-6 text-center">
                    <div className='ess-border'>
                        <h1>Category Wise Expenses</h1>
                        <div className='p-2 ess-chart flex'>
                            {categoryChartData?.datasets?.length > 0 ? <Chart type='bar' data={categoryChartData} /> : <p className='ess-no-data' style={{margin: "0"}}>No results found</p>}
                        </div>
                    </div>
                </div>
                <div className="col-12 md:col-6 text-center">
                    <div className='ess-border'>
                        <h1>User Wise Expenses</h1>
                        <div className='p-2 ess-chart flex'>
                            {userGraphData?.labels?.length > 0 ? <Chart type="doughnut" data={userGraphData} options={userChartOptions} /> : <p className='ess-no-data' style={{margin: "0"}}>No results found</p>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ExpenseDashboard;
